import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import AdminNavbar from "../AdminNavbar/AdminNavbar";
import "./CoursesUpdate.css";
import Calendar from "../Calendar/Calendar";
import joinnow from "../../Image/joinnow.png";
const apiUrll = process.env.REACT_APP_API_BASE_URL;

function CoursesUpdate() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newCourse, setNewCourse] = useState({ title: "", description: "", image: null, preview: "" });
  const [courses, setCourses] = useState([]);
  const apiUrl = `${apiUrll}/api/courses`;

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${apiUrl}/get-courses`);
        const data = await response.json();
        if (response.ok) {
          setCourses(data.courses);
        } else {
          console.error("Error fetching courses:", data.msg);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewCourse({ ...newCourse, image: file, preview: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddCourse = async () => {
    const formData = new FormData();
    formData.append("title", newCourse.title);
    formData.append("description", newCourse.description);
    formData.append("image", newCourse.image); 
    try {
      const response = await fetch(`${apiUrl}/add-course`, {
        method: "POST",
        body: formData,
      });
  
      const data = await response.json();
      if (response.ok) {
        setCourses([...courses, data.course]);
        setIsModalOpen(false);
        setNewCourse({ title: "", description: "", image: null, preview: "" });
      } else {
        console.error("Error adding course:", data.msg);
      }
    } catch (error) {
      console.error("Error adding course:", error);
    }
  };
  
  

  return (
    <div className="main-dashboard">
      <div>      <Sidebar /> </div>

      <div className="dashboard">
        <AdminNavbar />
        <div className="card-side">
          <div className="courses-container">
            <h2>All Courses</h2>
            <div className="courses-grid">
              {courses.map((course, index) => (
                <div key={index} className="Admin-card">
                  <div className="ribbon">
                    <img src={course.image} alt={course.title} />
                  </div>
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                </div>
              ))}
            </div>
            <button className="add-course-btn" onClick={() => setIsModalOpen(true)}>Add Course</button>
          </div>

          {isModalOpen && (
            <div className="modal-overlay">
              <div className="modal-course">
                <button className="close-button" onClick={() => setIsModalOpen(false)}>✖</button>
                <h2>Add Course</h2>
                <input
                  type="text"
                  placeholder="Enter course name"
                  value={newCourse.title}
                  onChange={(e) => setNewCourse({ ...newCourse, title: e.target.value })}
                />
                <textarea
                  placeholder="Enter course description"
                  value={newCourse.description}
                  onChange={(e) => setNewCourse({ ...newCourse, description: e.target.value })}
                ></textarea>

                
                <input type="file" accept="image/*" onChange={handleImageChange} />
                {newCourse.preview && <img src={newCourse.preview} alt="Preview" className="image-preview" />}

                <button className="save-button" onClick={handleAddCourse}>Save</button>
              </div>
            </div>
          )}

<div className="sidebarms">
            <Calendar />
            <div className="promotion">
              <img src={joinnow} alt="Join Now" />
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default CoursesUpdate;
